import React from "react";
import Logo from "../../assets/images/layout/footerlogo.webp"; 
import Facebook from "../../assets/images/layout/Facebook.webp"; 
import Instagram from "../../assets/images/layout/Instagram.webp"; 
import YouTube from "../../assets/images/layout/YouTube.webp"; 
import EmailSubscribeFooter from "../common/EmailSubscribeFooter";
import Space from "../common/Space";
import { Link } from "react-router-dom";
import GooglePlay from "../../assets/images/GooglePlay.jpeg";
import Apple from "../../assets/images/AppStore.jpeg";

const Footer = () => {
  return (
    <> 
    <section id="header-links" className="container-fluid bg-footer">
      <div className="py-4" />
    <Space/>
    <Space/>
    <div className="py-5 py-md-0" />
    <EmailSubscribeFooter/>
    <div className="py-4" />
    <section className="container-lg">
      <div className="row justify-content-center justify-content-md-start justify-content-lg-center gy-4 ps-md-3 ps-lg-0">

        <div className="col-11 col-lg-4">
          <img
            src={Logo}
            alt="Huntsville Islamic Center Logo"
            className="footer-logo"
            />
          <div className="fs-ss-16 fw-400 pt-4 text-white">
          Dedicated to fostering a community rooted in faith, service, and unity, HIC empowers individuals through spiritual growth and collective action. We provide meaningful opportunities for all to connect, learn, and serve. 
          </div> 
          <div className="py-3" />
          <a target="_blank" href="https://us.mohid.co/al/huntsville/hicm/masjid/online/vfr/campaign/ramadhan_fundraising" className="hover-ss-donate text-decoration-none mt-3 mt-md-0 bg-ss-secondary rounded-5 border-0 py-2 px-5 fs-ss-links text-dark fw-500">
          Donate
        </a>           
        </div>
        
        <div className="col-11 col-md-7 col-lg-5 d-flex justify-content-lg-end">
        <div className="col-8 col-md-6">
          <div className="fs-ss-24 fw-500 text-ss-secondary">
            Services
          </div>
          <div className="fs-ss-16 fw-500 text-white">
          <div className="pt-3"> <Link className="text-decoration-none header-link text-white" to="/marital-ceremonies"> Marriage Ceremonies </Link> </div>
        <div className="pt-3"> <Link className="text-decoration-none header-link text-white" to="/burial-services"> Burial Services </Link> </div>
          <div className="pt-3"> <Link className="text-decoration-none header-link text-white" to="/reverts"> Reverts </Link> </div>
          <div className="pt-3"> <Link className="text-decoration-none header-link text-white" to="/community-outreach"> Community Outreach </Link> </div>
          <div className="pt-3"> <a className="text-decoration-none header-link text-white" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLScsSOLZ7JXKa0v2RJ9CzzM9Xrgt2FQt0l8QL68zJHR_oY-8_g/viewform"> Imam Appointment </a> </div>
          </div>
        </div>

        <div className="col-5">
          <div className="fs-ss-24 fw-500 text-ss-secondary">
            Quick Links
          </div>
          <div className="fs-ss-16 fw-500 text-white">
           <div className="pt-3"> <Link className="text-decoration-none header-link text-white" to="/resources"> Resources </Link> </div>
          <div className="pt-3"> <Link className="text-decoration-none header-link text-white" to="/calendar"> Calendar </Link> </div>
          <div className="pt-3"> <Link className="text-decoration-none header-link text-white" to="/privacy-policy"> Privacy Policy </Link> </div>
          <div className="pt-3"> <Link className="text-decoration-none header-link text-white" to="/terms-and-conditions"> Terms & Conditions </Link> </div>
          </div>
        </div>
        </div>

        <div className="col-11 col-md-3 fw-500">
          <div className="">
                    <div className="fs-ss-24 fw-500 text-ss-secondary">
            Follow Us
          </div>
          <div className="py-2 py-md-0" />
          <div className="fs-ss-35">
          <a className="text-decoration-none text-ss-secondary me-2" target="_blank" href="https://www.facebook.com/hiccommunity"> <img src={Facebook} className="col-2 col-md-3 col-lg-2 px-1 hover-social-media" alt="Facebook" /> </a> 
          <a className="text-decoration-none text-ss-secondary me-2" target="_blank" href="https://www.instagram.com/hicmasjid"> <img src={Instagram} className="col-2 col-md-3 col-lg-2 px-1 hover-social-media" alt="Instagram" /> </a> 
          <a className="text-decoration-none text-ss-secondary" target="_blank" href="https://www.youtube.com/channel/UCq1M6eOaFxLc_yh22EgcYhA"> <img src={YouTube} className="col-2 col-md-3 col-lg-2 px-1 hover-social-media" alt="YouTube" /> </a> 
          </div>
          </div>

          <div className="pt-3">
            <div className="fs-ss-24 fw-500 text-ss-secondary">
            Download App
          </div>
          <div className="py-2 py-md-0" />
          <div className="fs-ss-35">
          <a className="text-decoration-none text-ss-secondary pe-3" target="_blank" href="https://play.google.com/store/apps/details?id=org.huntsvilleislamiccenter.app"> <img src={GooglePlay} className="col-5" alt="Facebook" /> </a> 
          <a className="text-decoration-none text-ss-secondary" target="_blank" href="https://apps.apple.com/pk/app/hic-connect/id6753870330"> <img src={Apple} className="col-5" alt="Facebook" /> </a> 
          </div>
          
          </div>
      </div>
        </div>
    </section>
    <div className="py-4" />
    </section>

    <section className="container-fluid py-1 fs-ss-15 bg-white">
    <div className="row justify-content-center">
    <div className="col-md-6 text-center fw-500">
       Copyright © Huntsville Islamic Center {new Date().getFullYear()} . All Rights Reserved 
      </div>
      </div>
      </section>
      </>
  );
}

export default Footer